import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class comprobanteService {

    /******* QUERIES ******/
    async listarEstado() {
        const response = await axios
            .get(`${ERP}ventas/comprobante/estado`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async paginacionComprobante(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/paginacion-comprobantes?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async comprobanteVinculado(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/documento-referencia?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async datosIniciales(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/datos-iniciales?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerSeriesPorIdUsuario(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/usuario-series?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async dashboard(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/dashboard?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async dashboardEstablecimiento(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/dashboard-establecimiento?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async dashboardCliente(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/dashboard-cliente?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async dashboardResumen(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/dashboard-resumen?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async dashboardGeneral(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/dashboard-general?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async dashboardVendedor(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/dashboard-vendedor?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async dashboardProducto(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/dashboard-producto?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async importarPorId(id) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/${id}?IsImporatacion=Imporatacion`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async ver(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/ver?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    async documentosNotaExcel(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/documentos-nota-excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async documentosNotaDetalleExcel(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/documentos-nota-excel-detalle?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    async documentosNotapdf(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/documentos-nota-pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    async documentosNotaDetallepdf(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/documentos-nota-detalle-pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdfA4(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/pdf-a4?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ticket(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/pdf-ticket?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async ticket50(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/pdf-ticket-50?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async xml(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/xml?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async cdr(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/cdr?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async importarEmitidos(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/importar-emitidos?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async importarRegistradosEmitidos(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/importar-registrados-emitidos?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async importarAnticipos(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/importar-anticipos?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}ventas/comprobante`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {

        const response = await axios
            .put(`${ERP}ventas/comprobante`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async emitir(data) {
        const response = await axios
            .put(`${ERP}ventas/comprobante/emitir`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async getCdr(data) {
        const response = await axios
            .put(`${ERP}ventas/comprobante/get-cdr`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async anular(data) {
        const response = await axios
            .put(`${ERP}ventas/comprobante/anular`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


    async enviarCorreo(data) {
        const response = await axios
            .put(`${ERP}ventas/comprobante/enviar-correo`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async listarTodos(filter) {
        const response = await axios
            .get(`${ERP}ventas/comprobante/listar-todos?${global.formatParameter(filter)}`)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new comprobanteService();